import React, { useState, useEffect } from 'react';
import { Typography, Button, Box, Chip } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import NumberFormat from 'react-number-format';
import { obtenerPresupuestosCPMesV } from '../../actions/PresupuestosAction';
import moment from 'moment';
import { useStateValue } from '../../contexto/store';

export default function CerradosPerdidosMesVendedor() {
  const [presupuestosTotal, setPresupuestosTotal] = useState([]);
  const [{ sesionUsuario }] = useStateValue();
  
  const actualizarTotales = () => {
    const desde = moment().startOf('month').format();
    const hasta = moment().endOf('month').format();
    const usuario = sesionUsuario.usuario.id;
    obtenerPresupuestosCPMesV(desde, hasta, usuario).then(response => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  };

  useEffect(() => {
    const desde = moment().startOf('month').format();
    const hasta = moment().endOf('month').format();
    const usuario = sesionUsuario.usuario.nombrecompleto;
    obtenerPresupuestosCPMesV(desde, hasta, usuario).then(response => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  }, [sesionUsuario]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0.5 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        mb: 2 
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #ef5350 0%, #e53935 100%)',
          boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
        }}>
          <TrendingDownIcon sx={{ color: 'white', fontSize: 28 }} />
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Chip 
            icon={<PersonIcon />}
            label={sesionUsuario.usuario?.nombrecompleto || ''}
            size="small"
            color="error"
            variant="outlined"
            sx={{ 
              fontSize: '0.7rem',
              height: 24,
              maxWidth: '100%',
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2, mt: 0.5 }}>
            Perdidos del Mes
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', mb: 2 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 800, 
            color: 'error.main',
            textAlign: 'left',
            fontSize: { xs: '1.75rem', sm: '2rem' }
          }}
        >
          <NumberFormat
            notranslate="true"
            value={presupuestosTotal.total}
            displayType="text"
            thousandSeparator="."
            decimalSeparator={false}
            prefix="₲ "
          />
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Mis presupuestos no concretados
        </Typography>
      </Box>

      <Button 
        variant="outlined" 
        color="error"
        onClick={actualizarTotales}
        startIcon={<RefreshIcon />}
        size="small"
        sx={{ 
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'error.light',
            color: 'white'
          }
        }}
      >
        Actualizar
      </Button>
    </Box>
  );
}
